import CountryPageRenderer from '../components/CountryPageRenderer';
import panamaData from '../data/country-pages/panama';

export default function PanamaCountryPage() {
  return <CountryPageRenderer data={panamaData} />;
}
